import React from 'react'
import { useNavigate } from 'react-router-dom'

import ButtonPrimary from "components/ButtonPrimary"

import styles from './styles.module.scss'

const Home = () => {

  const navigate = useNavigate()

  return (
    <div className={styles.homeContent__container}>
      <div className={styles.homeContent}>
        <img src="/images/logo_auth.png" alt="Simply Bail" />
        <h5 className="rad">Currently in Closed Beta</h5>
        <ButtonPrimary small color="navy" onClick={() => navigate(`/login`)}>Login</ButtonPrimary>
      </div>
    </div>
  ) 
}

export default Home